module.exports = __webpack_public_path__ + "img/Progress.45572931.png";